<template>
  <div>
    <el-form ref="searchform" :model="searchform" label-width="75px">
      <el-row>
        <el-col :span="6">
              <el-form-item label="仓库编码" prop="fromWarehouseCode">
                <el-input v-model.trim="searchform.fromWarehouseCode" style="width:100%" clearable></el-input>
              </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="产品" prop="productCode">
            <el-input v-model.trim="searchform.productCode" style="width:100%" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="扫码日期" prop="datelist">
            <el-date-picker
              style="width:100%"
              v-model="searchform.datelist"
              type="daterange"
              value-format="timestamp"
              range-separator="-"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button @click="resetForm('searchform')">重置</el-button>
          <el-button type="primary" @click="getsendcount()" icon="el-icon-search"> </el-button>
        </el-col>
      </el-row>
    </el-form>
    <line-chartc :chart-data="lineChartData" />
  </div>
</template>

<script>
import LineChartc from "../LineChartc";
import { sendcount } from "@/api/report";
export default {
  components: {
    LineChartc
  },
  data() {
    return {
      lineChartData: {
        expectedData:[],
        actualData: [],
        chartdatelist:[],

      },
      // 扫码查询参数
      searchform: {
        productCode: null,
        datelist: null,
        fromWarehouseCode :null,
      },
    };
  },
  methods: {
            //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 扫码查询次数
    getsendcount() {
      sendcount({
        fromWarehouseCode: this.searchform.fromWarehouseCode,
        productCode: this.searchform.productCode,
        time1:
          this.searchform.datelist == null ? null : this.searchform.datelist[0],
        time2:
          this.searchform.datelist == null ? null : this.searchform.datelist[1]
      }).then(response => {
        this.lineChartData.actualData = [];
        this.lineChartData.expectedData = [];
        this.lineChartData.chartdatelist = [];
        for (let i = 0; i < response.data.length; i++) {
          this.lineChartData.expectedData.push(response.data[i].qrcode1qty);
          this.lineChartData.actualData.push(response.data[i].qrcode2qty);
          response.data[i].createDate = response.data[i].createDate.substring(0,response.data[i].createDate.length - 8);
          this.lineChartData.chartdatelist.push(response.data[i].createDate);
        }
      });
    },
  },
  mounted() {
    // 图表初始数据调用
    this.getsendcount();
  }
};
</script>
<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
